import { createRoot } from 'react-dom/client';
import { Router } from 'react-router-dom';
import App from './components/app';
import history from './redux/history';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <Router history={history}>
    <App />
  </Router>
);
